export default __webpack_public_path__ + "static/media/pencil.65ef4bf8.svg";